






























































import { Mutation } from 'vuex-module-decorators';
import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { Event, EventGiftCcourse } from '@/models/jgrow/event';
import { masterModule } from '@/store/modules/entities/master.module';
import { StatisticsFilterParam } from '@/models/statistics/statistics-filter-param';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import { GPageBase } from '@/mixins';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { GEnum } from '@/constants/enum.defination';
import { AllEvalSetting } from '@/models/evalSetting/all-eval-setting';
import { Survey } from '@/models/jgrow/survey';
import { eventGiftCourseModule } from '@/store/modules/frames/event-gift-course.module';
import { CompetencyBoxplotEchartService } from '@/service/echart/competency-boxplot.echart.service';

interface SeriesCondition {
  grade: number;
  schoolClassName: string;
  tagContents: string[];
  evalSettingName: string;
}

@Component({
  name: 'GSurveyAnalyzeFilter',
  computed: {},
  methods: {},
})
export default class GSurveyAnalyzeFilter extends Mixins(GPageBase) {
  statisticsFilterParam: StatisticsFilterParam = new StatisticsFilterParam();
  seriesColumns: any[] = [];
  seriesLimit: number = 5;
  uniqueConditions: string[] = [];
  selectBfGiftCourseID: number = 0;
  selectAfGiftCourseID: number = 0;
  beforeEvalSettings: AllEvalSetting[] = [];
  afterEvalSettings: AllEvalSetting[] = [];

  async mounted() {
    this.beforeEvalSettings = this.allEvalSettings;
    this.afterEvalSettings = this.allEvalSettings;
    this.setSelectBfGiftCourseID(this.beforeEventGiftCourses[0] ? this.beforeEventGiftCourses[0].ID : 0);
    this.setSelectAfGiftCourseID(this.afterEventGiftCourses[0] ? this.afterEventGiftCourses[0].ID : 0);
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }

  get eventID(): number {
    return surveyAnalyzeModule.eventID;
  }

  get event(): Event {
    return surveyAnalyzeModule.event;
  }

  get beforeSurvey(): Survey {
    if (!this.event.surveys.length) return new Survey();
    return surveyAnalyzeModule.event.surveys.find((s: Survey) => s.type === GEnum.SurveysType.Before);
  }

  get afterSurvey(): Survey {
    if (!this.event.surveys.length) return new Survey();
    return surveyAnalyzeModule.event.surveys.find((s: Survey) => s.type === GEnum.SurveysType.After);
  }

  get giftCourses(): EventGiftCcourse[] {
    return surveyAnalyzeModule.event.giftCourses;
  }

  getSelectedEvalSettings(giftCourse: number): AllEvalSetting {
    return this.allEvalSettings.find((e: AllEvalSetting) => e.evalSettingID === giftCourse);
  }

  get beforeEvalSetting(): AllEvalSetting {
    return this.allEvalSettings.find((e: AllEvalSetting) => e.evalSettingID === this.selectBfGiftCourseID);
  }

  get afterEvalSetting(): AllEvalSetting {
    return this.allEvalSettings.find((e: AllEvalSetting) => e.evalSettingID === this.selectAfGiftCourseID);
  }

  get beforeEventGiftCourses(): EventGiftCcourse[] {
    return this.giftCourses.filter((g: EventGiftCcourse) => g.type === 1);
  }

  get afterEventGiftCourses(): EventGiftCcourse[] {
    return this.giftCourses.filter((g: EventGiftCcourse) => g.type === 2);
  }

  get allEvalSettings(): AllEvalSetting[] {
    return evalSettingModule.allEvalSettings;
  }

  updateBeforeEvalSettings() {
    if (evalSettingModule.allEvalSettings) {
      this.beforeEvalSettings = evalSettingModule.allEvalSettings.filter((eva: AllEvalSetting) => eva.evalSettingID !== this.selectAfGiftCourseID);
    } else {
      this.beforeEvalSettings = evalSettingModule.allEvalSettings;
    }
  }

  updateAfterEvalSettings() {
    if (evalSettingModule.allEvalSettings) {
      this.afterEvalSettings = evalSettingModule.allEvalSettings.filter((eva: AllEvalSetting) => eva.evalSettingID !== this.selectBfGiftCourseID);
    } else {
      this.afterEvalSettings = evalSettingModule.allEvalSettings;
    }
  }

  @Mutation
  setSelectBfGiftCourseID(value: number) {
    this.selectBfGiftCourseID = value;
  }

  @Mutation
  setSelectAfGiftCourseID(value: number) {
    this.selectAfGiftCourseID = value;
  }

  handleGiftCourse() {
    this.updateBeforeEvalSettings();
    this.updateAfterEvalSettings();
  }

  async handleAnalyze() {
    surveyAnalyzeModule.setBeforeEvalSetting(this.selectBfGiftCourseID);
    surveyAnalyzeModule.setAfterEvalSetting(this.selectAfGiftCourseID);
    await surveyAnalyzeModule.fetchCompetencyPulsAnalysis();
    await surveyAnalyzeModule.fetchCompetencyPlusGrowthTable();

    // 親経由でGSurveyCompetencyPlusGrowthAnalyzeのメソッドを呼びたい
    this.$emit('plus-growth-analyze-dataset');
    // コンピテンシー成長の表示に必用なデータの取得と事前にクリーン
    await eventGiftCourseModule.fetchCompetencyDistribution([this.selectBfGiftCourseID, this.selectAfGiftCourseID]);
    eventGiftCourseModule.setStudentAnswersAndScores();
    eventGiftCourseModule.setCompetencyGrowthTableSetupData();

    this.renderAddChart();
    this.showNotice(GEnum.MessageType.Success, this.INFO_TITLE, 'コンピテンシー成長分析情報を<br>' + this.UPDATE_SUCCESSED_MESSAGE);
  }

  renderAddChart() {
    // 初期化
    eventGiftCourseModule.setEChartService(new CompetencyBoxplotEchartService(masterModule.competencies));
    // コンピテンシー画面の描画
    eventGiftCourseModule.echartService.addLabel(1);
    eventGiftCourseModule.echartService.addSeries(eventGiftCourseModule.beforeExamCompetencyBoxplots);
    eventGiftCourseModule.echartService.addLabel(2);
    eventGiftCourseModule.echartService.addSeries(eventGiftCourseModule.afterExamCompetencyBoxplots);
  }
}
